import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { UserDataService } from '../../features/user-data.service';

@Component({
  selector: 'app-rdproject-recording',
  templateUrl: './rdproject-recording.component.html',
  styleUrls: ['./rdproject-recording.component.css']
})
export class RdprojectRecordingComponent implements OnInit {


  visible=false;
  token:any;
  record:any;
  recordProjects:any;
  userWithToken:any;
  error:any;
  searchText:any;
  users:any;
  projectUsers:any;
  loggedUser:any;
  toggle=true;

  rdName="";
  projectCode="";
  projectDetail="";

  constructor(private userData:UserDataService, private auth:AuthService, private route:Router ){}
   aslan=true;



    ngOnInit() {


     this.token=this.auth.token;
      this.loggedUser=this.auth.userMail;
      this.findRDCenter(); this.findProjects();
     }






  findRDCenter() {
    this.visible=!this.visible;
    this.userData.fetchRDCenter(this.token).subscribe(
     (res: any) => {
      if (!res) {
        this.record="Kayıtlı Ar-Ge Merkezi bulunamadı";
        alert("Kayıtlı Ar-Ge Merkezi bulunamadı")
      } else {

   //   console.log(res);
      this.userWithToken=res;
      this.users = Object.keys(res).map((key) =>
      { return res[key] });

      this.users.key = Object.keys(res).map((key) =>
      { return (key) });

     console.log(this.users);
      this.record=""
    }},err=>this.error=(err.statusText)
  );
  }
  findProjects() {
    this.visible=!this.visible;
    this.userData.fetchProjects(this.token).subscribe(
     (res: any) => {
      if (!res) {
        this.recordProjects="Kayıtlı Proje bulunamadı";
        alert("Kayıtlı Proje bulunamadı")
      } else {

   //   console.log(res);
      this.userWithToken=res;
      this.projectUsers = Object.keys(res).map((key) =>
      { return res[key] });

      this.projectUsers.key = Object.keys(res).map((key) =>
      { return (key) });

     console.log(this.users);
      this.recordProjects=""
    }},err=>this.error=(err.statusText)
  );
  }
  removeRDCenter(i:number) {
    console.log(this.users[i]);
    if(confirm(`${this.users[i][0].centerName}- Ar-Ge Merkezinin kaydı silinecektir. Onaylıyor musunuz?`)){
   // console.log(this.users[i][0]);
   /* this.userData.deletionRecords([this.loggedUser,Date.now()],"Başvuru Sahibi kaydı silindi",this.users[i][0]).subscribe();*/
   this.userData.deletionRecords([this.loggedUser,Date.now()],'Ar-Ge Merkezi kaydı silindi', `Silinen Ar-Ge Merkezi: ${this.users[i][0].centerName} `).subscribe();
   // console.log(this.loggedUser);
    /* this.http.delete('https://sisecam-a8421-default-rtdb.firebaseio.com/patents/'+ this.users.key[i] +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));*/
    this.userData.removeRDCenter(this.users.key[i]);
    this.route.navigateByUrl('/bbf', {skipLocationChange: true}).then(()=>
    this.route.navigate(['masterData']));
  alert('Ar-Ge Merkezi kaydı silindi')}
    //this.redirectTo('masterData');
  }
  removeProject(i:number) {
    console.log(this.projectUsers[i]);
    if(confirm(`${this.projectUsers[i][0].projectCode}- Proje kaydı silinecektir. Onaylıyor musunuz?`)){
   // console.log(this.users[i][0]);
   /* this.userData.deletionRecords([this.loggedUser,Date.now()],"Başvuru Sahibi kaydı silindi",this.users[i][0]).subscribe();*/
   this.userData.deletionRecords([this.loggedUser,Date.now()],'Proje kaydı silindi', `Silinen Projenin Kodu: ${this.projectUsers[i][0].projectCode} `).subscribe();
   // console.log(this.loggedUser);
    /* this.http.delete('https://sisecam-a8421-default-rtdb.firebaseio.com/patents/'+ this.users.key[i] +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));*/
    this.userData.removeProject(this.projectUsers.key[i]);
    this.route.navigateByUrl('/bbf', {skipLocationChange: true}).then(()=>
    this.route.navigate(['masterData']));
  alert('Proje kaydı silindi')}
    //this.redirectTo('masterData');
  }



  redirectTo(uri:string){
    this.route.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.route.navigate([uri]));
 }
 recordRDCenter() {
  let recording=[];
  recording.push({recordingUser:this.loggedUser, date:Date.now()});
  this.userData.addRDCenter(this.rdName,recording).
    subscribe(arr=>{console.log(arr);
    alert("Ar-Ge Merkezi kaydedildi")},
    err=>{
    this.error=err.statusText;
    console.log(this.error)});
    this.users=[];
    this.record="Ar-Ge Merkezi Kaydedildi";
    this.route.navigateByUrl('/bbf', {skipLocationChange: true}).then(()=>
    this.route.navigate(['masterData']));
 }
 recordProject(){
  let recording=[];
  recording.push({recordingUser:this.loggedUser, date:Date.now()});
  this.userData.addProject(this.projectCode,this.projectDetail,recording).
    subscribe(arr=>{console.log(arr);
    alert("Proje kaydedildi")},
    err=>{
    this.error=err.statusText;
    console.log(this.error)});
    this.users=[];
    this.route.navigateByUrl('/bbf', {skipLocationChange: true}).then(()=>
    this.route.navigate(['masterData']));

 }

}
